import React from 'react';
import { Container } from 'react-bootstrap';
import './MainFooter.css';

const MainFooter = () => {
  return (
    <footer className="main-footer d-none d-md-block">
      <Container className="d-flex justify-content-center align-items-center">
        <img src="/logo.svg" alt="AutoLexi logo" className="footer-logo" />
      </Container>
    </footer>
  );
};

export { MainFooter };
